import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap";

// Connects to data-controller="modal"
export default class extends Controller {

  initialize() {
    this.element.addEventListener("turbo:before-fetch-response", (event) => {
      const response = event.detail.fetchResponse.response
      if (response.status == "204") {
        this.modal.hide()
      }
    })
  }

  connect() {
    this.modal = new Modal(this.element);
    document.getElementById('modal').classList.remove("hidden")
    this.modal.show();

    // Remove any existing backdrop
    let backdrop = document.querySelector(".modal-backdrop");
    if (backdrop) {
      backdrop.remove();
    }

    // Add event listeners for modal cleanup
    this.element.addEventListener("hidden.bs.modal", this.cleanup.bind(this));
    this.element.addEventListener("hide.bs.modal", this.cleanup.bind(this));

    // Add event listener for turbo:before-stream-render
    document.addEventListener('turbo:before-stream-render', (event) => {
      const target = event.target.getAttribute('target');
      if (target === 'remote_modal_body') {
        this.scrollToTop();
      }
    });
  }

  scrollToTop() {
    const modalBody = document.getElementById('remote_modal_body')
    if (modalBody) {
      modalBody.parentNode.parentNode.parentNode.scrollTop = 0;
    }
  }

  cleanup() {
    // Remove modal-open class from body
    document.body.classList.remove('modal-open');
    
    // Remove modal-backdrop
    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) {
      backdrop.remove();
    }
    
    // Reset body styles
    document.body.style.paddingRight = '';
    document.body.style.overflow = '';
    document.body.style.position = '';
    
    // Hide the modal frame
    const modalFrame = document.getElementById('modal');
    if (modalFrame) {
      modalFrame.classList.add('hidden');
      modalFrame.innerHTML = '';
    }
  }

  disconnect() {
    this.cleanup();
  }
}